import React from "react"
import styles from "./simpleplayercontrol.module.scss"
import ReactPlayer from "react-player"
import { Box } from "@mui/system";
import { Fab } from "@mui/material";
import { logEvent } from "analyticsEvents";


interface Props {
  songUrl: string,
  songId: string,
  isPlaying: boolean,
  onPlayPauseTapped: () => void
}

const SimplePlayerControl = (props: Props) => {
  return (
    <div className={styles.playerControlsRoot}>
      <Box className={styles.buttonContainer} display='flex' flexDirection='row' justifyContent="space-evenly" alignItems="center">
        <Fab
          className={styles.playPauseButton}
          sx={{
            backgroundColor: "rgba(0,0,0,0.75)",
            '&:hover': {
              backgroundColor: "rgba(200,200,200,0.5)"
            }
          }}
          onClick={() => {
            logEvent('song_play_toggled', {
              song_id: props.songId,
              newPlaybackState: !props.isPlaying
            });
            props.onPlayPauseTapped();
          }}
        >
          <img
            className={styles.playPauseIcon}
            src={props.isPlaying ? require("../../resources/pause.svg").default : require("../../resources/play.svg").default}
            />
        </Fab>
      </Box>
      <ReactPlayer
        hidden
        url={props.songUrl}
        playing={props.isPlaying}
        config={{
          file: {
            forceAudio: true,
          },
        }}
      />
    </div>
  )
}

export default SimplePlayerControl
